import * as React from "react";
import Modal from "@mui/material/Modal";

import classes from "./LighterModal.module.css";
import AuthContext from "../../../../Common/auth-context";
import AddLighter from "./AddLighter";

const LighterModal = (props) => {
  const { lable, handleClose } = props;
  const authCtx = React.useContext(AuthContext);
  // console.log(client_name);
  return (
    <div>
      <Modal
        open={authCtx.openLighterModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={classes.maincontainer}>
          <div className={classes.mainheader}>
            <p className={classes.mainhead}>Lighters & Cutters</p>
            <p>{lable}</p>
          </div>
          <div className={classes.storecontainer}>
            <AddLighter onClose={props.handleClose}/>
          </div>


        </div>
      </Modal>
    </div>
  );
};

export default LighterModal;
